import { transition } from '@helpers/animation';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand, { colourWithTransparency } from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';
const Container = styled.a `
  position: relative;
  display: inline-flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  text-decoration: none;
  padding: 15px;
  margin: 0;
  box-shadow: 0 0 4px ${colourWithTransparency(brand.black, 0.25)};
  border-radius: 5px;
  max-width: 410px;
`;
const ImageContainer = styled.div `
  ${imageWrapperPreserveRatio(380, 334)};

  position: relative;
  width: 100%;
`;
const Image = styled.img `
  ${transition('transform, opacity')};
  ${imageCoverContainer()};

  width: 100%;
  max-width: 384px;
  border-radius: 5px;
  transition-delay: calc(100ms * var(--i));

  ${Container}[data-visible='false'] & {
    opacity: 0;
    transform: translateY(50%);
  }
`;
const TagText = styled.div `
  ${transition('transform, opacity')};
  ${fonts.inter.extraBold};

  position: absolute;
  left: 0;
  top: 0;
  height: 40px;
  background-color: ${brand.primary.blue.base};
  border: ${fluid(1, 2)} solid ${brand.white};
  border-left: 0;
  border-top: 0;
  border-radius: 4px 0 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition-delay: calc(300ms * var(--i));
  font-size: 12px;
  line-height: 24px;
  color: ${brand.white};
  padding: 10px 40px 10px 25px;

  ${Container}[data-visible='false'] & {
    opacity: 0;
    transform: translateX(-100%);
  }
`;
const BrandLogo = styled.img `
  position: absolute;
  right: 10px;
  top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  max-height: 38px;
`;
const OfferTextContainer = styled.div `
  ${transition('transform, opacity')};

  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateY(-30px);
  transition-delay: calc(250ms * var(--i));

  ${Container}[data-visible='false'] & {
    opacity: 0;
    transform: translateY(20px);
  }
`;
const ContentContainer = styled.div `
  ${transition('transform, opacity')};

  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  transition-delay: calc(250ms * var(--i));

  ${Container}[data-visible='false'] & {
    opacity: 0;
    transform: translateY(20px);
  }
`;
const Title = styled.div `
  ${fonts.inter.extraBold};

  font-size: 18px;
  margin-bottom: 16px;
  color: ${brand.black};
  text-align: center;
`;
const PriceContainer = styled.div ``;
const Price = styled.span `
  ${fonts.inter.extraBold};

  position: relative;
  background-color: ${brand.primary.grey.light};
  color: ${brand.black};
  font-size: 18px;
  padding: 12px 10px;
  border-radius: 5px;

  @media ${from(Device.DesktopSmall)} {
    font-size: 20px;
  }

  @media ${from(Device.Desktop)} {
    font-size: 14px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 18px;
  }

  ${({ goldBackground }) => goldBackground &&
    css `
      background-color: ${brand.primary.blue.base};
      color: ${brand.white};
    `}
`;
const Content = styled.div `
  ${fonts.sofiaPro.medium};
  font-size: 18px;
  color: ${brand.black};
  text-align: center;
  margin-bottom: auto;
  padding-bottom: 24px;
  line-height: 28px;

  + a {
    width: 100%;
  }
`;
export const OfferDetailCardStyles = {
    Container,
    ImageContainer,
    Image,
    ContentContainer,
    OfferTextContainer,
    Title,
    PriceContainer,
    Price,
    TagText,
    BrandLogo,
    Content,
};
